import React from 'react';

type NexusToastType = 'success' | 'error' | 'warning' | 'info';

interface NexusToastProps {
    type: NexusToastType;
    message: string;
}

const NexusToast: React.FC<NexusToastProps> = ({ message }) => {
    return (
        <div className='flex items-start gap-3 p-4 rounded-lg shadow-lg bg-white border border-gray-200 min-w-[250px]'>
            <div className='text-sm text-gray-900'>{message}</div>
        </div>
    );
};

export default NexusToast;
